var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatrivisProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 780,
    viewBox: "0 0 1600 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 780,
    fill: "url(#paint0_linear_562_563)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 449.794V363.67H590.615L634.37 425.781L629.636 424.857L673.276 363.67H673.507V449.794H662.424V389.068L663.116 394.725L631.599 439.288H631.368L599.389 394.725L601.352 389.53V449.794H590.5ZM689.179 449.794L725.661 362.862H726.354L762.72 449.794H749.905L722.659 380.41L730.625 375.215L700.147 449.794H689.179ZM710.537 418.161H741.593L745.287 427.859H707.305L710.537 418.161ZM765.783 366.325H821.197V377.062H798.801V449.794H787.602V377.062H765.783V366.325ZM861.149 366.325C865.382 366.325 869.268 366.902 872.809 368.057C876.426 369.134 879.543 370.789 882.16 373.021C884.854 375.176 886.932 377.87 888.394 381.102C889.934 384.258 890.703 387.952 890.703 392.185C890.703 395.495 890.203 398.727 889.202 401.883C888.279 405.039 886.701 407.925 884.469 410.542C882.237 413.081 879.312 415.159 875.695 416.776C872.155 418.315 867.768 419.085 862.534 419.085H850.181V449.794H838.983V366.325H861.149ZM862.303 408.348C865.613 408.348 868.345 407.848 870.5 406.847C872.732 405.847 874.464 404.577 875.695 403.037C876.926 401.421 877.812 399.689 878.35 397.842C878.889 395.995 879.158 394.263 879.158 392.647C879.158 390.954 878.851 389.222 878.235 387.452C877.696 385.605 876.773 383.912 875.464 382.372C874.233 380.833 872.578 379.563 870.5 378.563C868.499 377.562 866.036 377.062 863.111 377.062H850.181V408.348H862.303ZM876.041 414.698L897.861 449.794H884.931L862.765 415.044L876.041 414.698ZM915.083 366.325H926.282V449.794H915.083V366.325ZM956.262 366.325L983.739 435.363L977.389 434.093L1003.48 366.325H1016.53L979.698 453.603L942.986 366.325H956.262ZM1033.24 366.325H1044.44V449.794H1033.24V366.325ZM1111.59 381.218C1108.74 379.755 1105.62 378.486 1102.24 377.408C1098.85 376.331 1095.54 375.792 1092.31 375.792C1087.85 375.792 1084.27 376.831 1081.57 378.909C1078.96 380.987 1077.65 383.758 1077.65 387.221C1077.65 389.838 1078.49 392.07 1080.19 393.917C1081.88 395.687 1084.11 397.227 1086.88 398.535C1089.65 399.843 1092.54 401.075 1095.54 402.229C1098.16 403.23 1100.74 404.346 1103.28 405.577C1105.82 406.809 1108.09 408.348 1110.09 410.195C1112.17 412.042 1113.78 414.313 1114.94 417.007C1116.17 419.7 1116.78 423.048 1116.78 427.051C1116.78 431.438 1115.67 435.44 1113.44 439.057C1111.28 442.674 1108.16 445.522 1104.09 447.6C1100.01 449.678 1095.16 450.717 1089.54 450.717C1085.84 450.717 1082.3 450.294 1078.92 449.447C1075.61 448.601 1072.53 447.523 1069.68 446.215C1066.83 444.829 1064.29 443.406 1062.06 441.943L1067.03 433.169C1068.87 434.478 1070.99 435.748 1073.38 436.979C1075.76 438.133 1078.26 439.096 1080.88 439.865C1083.5 440.558 1086.04 440.904 1088.5 440.904C1091.12 440.904 1093.7 440.442 1096.24 439.519C1098.85 438.518 1101.01 437.017 1102.7 435.016C1104.39 433.015 1105.24 430.36 1105.24 427.051C1105.24 424.203 1104.47 421.855 1102.93 420.008C1101.47 418.084 1099.51 416.468 1097.04 415.159C1094.58 413.774 1091.96 412.543 1089.19 411.465C1086.58 410.465 1083.92 409.387 1081.23 408.233C1078.53 407.001 1076.03 405.539 1073.72 403.846C1071.41 402.075 1069.57 399.92 1068.18 397.38C1066.8 394.841 1066.1 391.762 1066.1 388.145C1066.1 383.758 1067.14 379.948 1069.22 376.715C1071.38 373.406 1074.3 370.828 1077.99 368.98C1081.69 367.056 1085.92 366.017 1090.69 365.863C1096.08 365.863 1100.81 366.517 1104.89 367.826C1109.05 369.134 1112.71 370.751 1115.86 372.675L1111.59 381.218Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 449.794V363.67H590.615L634.37 425.781L629.636 424.857L673.276 363.67H673.507V449.794H662.424V389.068L663.116 394.725L631.599 439.288H631.368L599.389 394.725L601.352 389.53V449.794H590.5ZM689.179 449.794L725.661 362.862H726.354L762.72 449.794H749.905L722.659 380.41L730.625 375.215L700.147 449.794H689.179ZM710.537 418.161H741.593L745.287 427.859H707.305L710.537 418.161ZM765.783 366.325H821.197V377.062H798.801V449.794H787.602V377.062H765.783V366.325ZM861.149 366.325C865.382 366.325 869.268 366.902 872.809 368.057C876.426 369.134 879.543 370.789 882.16 373.021C884.854 375.176 886.932 377.87 888.394 381.102C889.934 384.258 890.703 387.952 890.703 392.185C890.703 395.495 890.203 398.727 889.202 401.883C888.279 405.039 886.701 407.925 884.469 410.542C882.237 413.081 879.312 415.159 875.695 416.776C872.155 418.315 867.768 419.085 862.534 419.085H850.181V449.794H838.983V366.325H861.149ZM862.303 408.348C865.613 408.348 868.345 407.848 870.5 406.847C872.732 405.847 874.464 404.577 875.695 403.037C876.926 401.421 877.812 399.689 878.35 397.842C878.889 395.995 879.158 394.263 879.158 392.647C879.158 390.954 878.851 389.222 878.235 387.452C877.696 385.605 876.773 383.912 875.464 382.372C874.233 380.833 872.578 379.563 870.5 378.563C868.499 377.562 866.036 377.062 863.111 377.062H850.181V408.348H862.303ZM876.041 414.698L897.861 449.794H884.931L862.765 415.044L876.041 414.698ZM915.083 366.325H926.282V449.794H915.083V366.325ZM956.262 366.325L983.739 435.363L977.389 434.093L1003.48 366.325H1016.53L979.698 453.603L942.986 366.325H956.262ZM1033.24 366.325H1044.44V449.794H1033.24V366.325ZM1111.59 381.218C1108.74 379.755 1105.62 378.486 1102.24 377.408C1098.85 376.331 1095.54 375.792 1092.31 375.792C1087.85 375.792 1084.27 376.831 1081.57 378.909C1078.96 380.987 1077.65 383.758 1077.65 387.221C1077.65 389.838 1078.49 392.07 1080.19 393.917C1081.88 395.687 1084.11 397.227 1086.88 398.535C1089.65 399.843 1092.54 401.075 1095.54 402.229C1098.16 403.23 1100.74 404.346 1103.28 405.577C1105.82 406.809 1108.09 408.348 1110.09 410.195C1112.17 412.042 1113.78 414.313 1114.94 417.007C1116.17 419.7 1116.78 423.048 1116.78 427.051C1116.78 431.438 1115.67 435.44 1113.44 439.057C1111.28 442.674 1108.16 445.522 1104.09 447.6C1100.01 449.678 1095.16 450.717 1089.54 450.717C1085.84 450.717 1082.3 450.294 1078.92 449.447C1075.61 448.601 1072.53 447.523 1069.68 446.215C1066.83 444.829 1064.29 443.406 1062.06 441.943L1067.03 433.169C1068.87 434.478 1070.99 435.748 1073.38 436.979C1075.76 438.133 1078.26 439.096 1080.88 439.865C1083.5 440.558 1086.04 440.904 1088.5 440.904C1091.12 440.904 1093.7 440.442 1096.24 439.519C1098.85 438.518 1101.01 437.017 1102.7 435.016C1104.39 433.015 1105.24 430.36 1105.24 427.051C1105.24 424.203 1104.47 421.855 1102.93 420.008C1101.47 418.084 1099.51 416.468 1097.04 415.159C1094.58 413.774 1091.96 412.543 1089.19 411.465C1086.58 410.465 1083.92 409.387 1081.23 408.233C1078.53 407.001 1076.03 405.539 1073.72 403.846C1071.41 402.075 1069.57 399.92 1068.18 397.38C1066.8 394.841 1066.1 391.762 1066.1 388.145C1066.1 383.758 1067.14 379.948 1069.22 376.715C1071.38 373.406 1074.3 370.828 1077.99 368.98C1081.69 367.056 1085.92 366.017 1090.69 365.863C1096.08 365.863 1100.81 366.517 1104.89 367.826C1109.05 369.134 1112.71 370.751 1115.86 372.675L1111.59 381.218Z",
    fill: "url(#paint1_linear_562_563)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 498.636,
    y: 363.461,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 498.636,
    y: 386.14,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 498.636,
    y: 409.371,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 498.636,
    y: 432.603,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 521.867,
    y: 363.461,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 521.867,
    y: 386.14,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 521.867,
    y: 409.371,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 521.867,
    y: 432.603,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 544.545,
    y: 363.461,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 544.545,
    y: 386.14,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 544.545,
    y: 409.371,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 544.545,
    y: 432.603,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 475.957,
    y: 363.461,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 475.957,
    y: 386.14,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 475.957,
    y: 409.371,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 475.957,
    y: 432.603,
    width: 17.7004,
    height: 17.7004,
    fill: "#FFCC00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_562_563",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 780,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_562_563",
    x1: 578.493,
    y1: 421.294,
    x2: 1124.49,
    y2: 421.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrivisProject);
export default __webpack_public_path__ + "static/media/matrivis-project.4c3e0d9958220636c3906b14a7d4ee6e.svg";
export { ForwardRef as ReactComponent };